import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Listen for Bootstrap tab shown event
    const tabButtons = this.element.querySelectorAll('button[data-bs-toggle="tab"]')
    tabButtons.forEach((button) => {
      button.addEventListener("shown.bs.tab", this.updateURL.bind(this))
    })
  }

  updateURL(event) {
    const button = event.target

    // Get tab name from data-tab-name attribute
    const tabName = button.dataset.tabName

    if (!tabName) {
      console.warn("Tab button missing data-tab-name attribute:", button)
      return
    }

    // Update URL without page reload
    const url = new URL(window.location)
    url.searchParams.set("tab", tabName)
    window.history.pushState({}, "", url)

    console.log("Tab changed to:", tabName)
  }
}
